import React from "react";
import { graphql, StaticQuery, Link } from "gatsby";
import styled from 'styled-components';
import { rhythm } from "../utils/typography";
import EmojiWrapper from "./EmojiWrapper";
import kebabCase from "lodash.kebabcase";

const CategoryButtonComp = styled.small`
    display:inline-block;    
    padding: ${rhythm(0.2)} ${rhythm(0.4)};
    margin:${rhythm(0.2)};
    background-color: var(--color-foreground);
    border-radius:8px;
    color:var(--color-headingFont);
    will-change: transform;
    transition: transform 250ms;
    :hover{
        transition: transform 150ms;
        transform:translateY(-6px);
        background-color: var(--color-gray3);

    }
`;

export const CategoriesQueryComponent = ({ children }) => {
    return (
        <StaticQuery
            query={graphql`
            query {
                categories:  allMdx {
                    distinct(field: frontmatter___category)
                }
            }
          `}
            render={data => <>{children(data)}</>}
        />
    )
}

export const CategoryButton = ({ data }) => {
    const { distinct: categories } = data.categories;
    return (
        categories.map(category => (
            <Link key={category} to={`/categories/${kebabCase(category.toLowerCase())}`}>
                <CategoryButtonComp>
                    {category}
                </CategoryButtonComp>
            </Link>
        ))
    )
};

export const CategorySection = () => (
    <div>
        <h4 style={{
            color: 'var(--color-primary)',
            marginLeft: rhythm(0.5)
        }}>
            <EmojiWrapper emoji="📚" name="categories" /> Categories
        </h4>
        <CategoriesQueryComponent>
            {data => <CategoryButton data={data} />}
        </CategoriesQueryComponent>
    </div>
)